// ============================================================
// vinylSKUs.js
// SKU mapping for the Vinyl (PVC) Privacy estimator.
// Pure data only — no prices here. Prices live in the Price List
// (Firestore) and are resolved by SKU in vinylCalc.js.
// Product: PVC Full Privacy panels, 6' tall x 8' wide. One style, one height.
// ============================================================

// --- Panels & Posts ---
export const VINYL_PANEL_SKU = 'PVCA68';       // PVC Fence Panel Full Privacy 6' x 8'
export const VINYL_LINE_POST_SKU = 'PVCPOSTL5';  // PVC Line Post 5x5
export const VINYL_CORNER_POST_SKU = 'PVCPOSTC5'; // PVC Corner Post 5x5
export const VINYL_END_POST_SKU = 'PVCPOSTE5';    // PVC End Post 5x5

// --- Post Caps (1 per post; user-selectable; default = Horse) ---
// Only 5x5 caps are used.
export const VINYL_CAP_SKU = {
  horse: 'PVCPCH5',        // Horse Cap 5x5 (DEFAULT)
  frenchGothic: 'PVCPCJ5', // French Gothic 5x5
  newEngland: 'PVCPCNE5',  // New England 5x5
};

// --- Gates ---
// Gates are prebuilt panels by width (4' or 5'), plus loose hardware.
export const VINYL_GATE_PANEL_SKU = {
  '4': 'PVCGATE4X6', // PVC Gate Full Privacy 4' W x 6' H
  '5': 'PVCGATE5X6', // PVC Gate Full Privacy 5' W x 6' H
};

// --- Gate Hardware ---
// Per gate leaf: 1 stiffener + 1 hinge set.
export const VINYL_GATE_STIFFENER_SKU = 'AS55'; // Aluminum Stiffener 5x5
export const VINYL_GATE_HINGE_SKU = 'PVCGATEH'; // Hinge Set Self Closing PVC (pair)

// Latch: one type chosen for the whole job (default = paddle).
// Single gate = 1 latch. Double pair = 1 latch (shared).
export const VINYL_LATCH_SKU = {
  paddle: 'PVCGATEPDL', // Paddle Latch (PVC) (DEFAULT)
  topPull: 'MLJR',      // Trident 10 Top Pull Latch Junior (for pools)
};

// Drop rod: 1 per double pair only.
export const VINYL_DROP_ROD_SKU = 'PVCDR'; // Drop Rod for PVC
